"use client"

import { useState, useEffect } from "react"
import { Send } from "lucide-react"

export default function MessageInput({ message, setMessage, handleSendMessage }) {
  const [localMessage, setLocalMessage] = useState(message)

  const handleChange = (e) => {
    setLocalMessage(e.target.value) // Usamos estado local para manejar el mensaje
  }

  // Solo actualizar el estado principal cuando sea necesario
  useEffect(() => {
    setMessage(localMessage)
  }, [localMessage, setMessage])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!localMessage.trim()) return

    handleSendMessage(e)
    setLocalMessage("") // Limpiamos el input después de enviar
  }

  return (
    <form onSubmit={handleSubmit} className="w-full p-4 bg-[var(--navy-blue-light)] ">
      <div className="flex items-center gap-2 w-full border rounded-lg overflow-hidden shadow-sm focus-within:ring-2 focus-within:ring-primary/50 focus-within:border-primary">
        <input
          type="text"
          value={localMessage}
          onChange={handleChange}
          placeholder="Escribe un mensaje..."
          className="flex-1 px-4 py-3 text-sm focus:outline-none"
        />
        <button
          type="submit"
          disabled={!localMessage.trim()}
          className="p-3 text-primary hover:bg-gray-100 disabled:text-gray-300 disabled:hover:bg-transparent transition-colors mr-1"
          aria-label="Enviar mensaje"
        >
          <Send className="w-5 h-5" />
        </button>
      </div>
    </form>
  )
}

